import { createGoviewProject } from '@/api/goview';
import { Form, Input, message, Modal } from 'antd';
import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react';

export interface CreateProjectModalRef {
  open: () => void;
}

export interface CreateProjectModalProps {
  onFinish?: () => void;
}

export const CreateProjectModal = forwardRef<CreateProjectModalRef, CreateProjectModalProps>(
  ({ onFinish }, ref) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const handleClose = useCallback(() => {
      form.resetFields();
      setIsModalOpen(false);
    }, [form]);

    useImperativeHandle(
      ref,
      () => {
        return {
          open() {
            setIsModalOpen(true);
          },
        };
      },
      [],
    );

    const handleSubmit = async () => {
      try {
        const values = await form.validateFields();
        setSubmitting(true);
        const resp = await createGoviewProject({ name: values.name });
        if (resp.success) {
          message.success('创建成功');
          handleClose();
          onFinish?.();
        } else {
          message.error(resp.errorMsg || '创建失败');
        }
      } catch (error) {
        console.error('表单验证失败', error);
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <Modal
        title="创建项目"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={handleClose}
        okText="确定"
        cancelText="取消"
        confirmLoading={submitting}
        maskClosable={false}
        destroyOnHidden
      >
        <Form layout="vertical" form={form}>
          <Form.Item
            label="项目名称"
            name="name"
            rules={[{ required: true, message: '请输入项目名称' }]}
          >
            <Input placeholder="请输入项目名称" />
          </Form.Item>
        </Form>
      </Modal>
    );
  },
);


